import { FC } from 'react';

interface TextAreaProps {
  value?: string;

  placeholder?: string;

  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  e2e?: string;

  rows?: number;
  onValueChanged?: (val: string) => void;
}

export const TextArea: FC<TextAreaProps> = ({
  value = '',
  onValueChanged,
  className,
  e2e,
  disabled,
  readOnly,
  placeholder,
  rows,
}) => {
  return (
    <textarea
      className={className}
      placeholder={placeholder}
      data-e2e={e2e}
      disabled={disabled}
      readOnly={readOnly}
      value={value}
      onChange={e => onValueChanged?.(e.target.value)}
      rows={rows}
    />
  );
};
